
import loadable from '@loadable/component';

export const DocumentLayout = loadable(() => import(
  /* webpackChunkName: "document-layout" */
  /* viteChunkName: "document-layout" */
  './document_layuot'
  ));

export  const  PrivacyPolicy = loadable(() => import(
  /* webpackChunkName: "privacy-policy" */
  /* viteChunkName: "privacy-policy" */
  './privacy-policy'
  ));
export const  PersonalDataProcessingPolicy  = loadable(() => import(
  /* webpackChunkName: "personal-data-processing-policy" */
  /* viteChunkName: "personal-data-processing-policy" */
  './personal-data-processing-policy'
  ))
export const ConsentToPersonalDataProcessing = loadable(() => import(
  /* webpackChunkName: "consent-to-personal-data-processing" */
  /* viteChunkName: "consent-to-personal-data-processing" */
  './consent-to-personal-data-processing'
  ))
export const UserAgreement= loadable(() => import(
  /* webpackChunkName: "user-agreement" */
  /* viteChunkName: "user-agreement" */
  './user-agreement'
  ))